import React from 'react'
import { BsGithub, BsLinkedin, BsInstagram } from 'react-icons/bs';
import { SiGooglescholar, SiLeetcode } from 'react-icons/si';

const SocialMedia = () => {
  return (
    <div className='app__social'>

        <div>
          <a href="https://scholar.google.com/citations?user=4odd99AAAAAJ&hl=en" target='blank'>
            <SiGooglescholar />
          </a>
        </div>

        <div>
          <a href="https://github.com/Bishaljay" target='blank'>
            <BsGithub />
          </a>
        </div>
      
        <div>
          <a href="https://www.linkedin.com/in/bishal-7bj/" target='blank'>
            <BsLinkedin />
          </a>
        </div>

        <div>
          <a href="https://leetcode.com/u/bishaljaysawal/" target='blank'>
            <SiLeetcode />
          </a>
        </div>

        <div>
          <a href="https://www.instagram.com/_jbishal7/" target='blank'>
            <BsInstagram />
          </a>
        </div>

    </div>
  )
}

export default SocialMedia
